{
  "name": "@html-eslint/parser",
  "version": "0.65.0",
  "description": "Parser for @html-eslint/eslint-plugin",
  "author": {
    "name": "yeonjuan",
    "url": "https://github.com/yeonjuan"
  },
  "homepage": "https://github.com/yeonjuan/html-eslint#readme",
  "license": "MIT",
  "main": "lib/index.js",
  "type": "commonjs",
  "types": "types/exports.d.ts",
  "files": [
    "lib",
    "types"
  ],
  "publishConfig": {
    "access": "public"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/yeonjuan/html-eslint.git"
  },
  "scripts": {
    "test": "jest --coverage --updateSnapshot",
    "ts": "tsc --noEmit",
    "build": "rimraf types && tsc --project tsconfig.build.json"
  },
  "bugs": {
    "url": "https://github.com/yeonjuan/html-eslint/issues"
  },
  "keywords": [
    "html",
    "eslint",
    "parser",
    "ast",
    "lint"
  ],
  "dependencies": {
    "@html-eslint/template-syntax-parser": "^0.65.0",
    "@html-eslint/types": "^0.65.0",
    "css-tree": "^3.1.0",
    "es-html-parser": "0.3.1"
  },
  "devDependencies": {
    "@types/css-tree": "^2.3.11"
  }
}
